import { memo } from 'react'

import { Slider } from '@components/Slider'
import Case from '@dynamic-components/sections/Case'
import { Description } from '@ui/sections/Description'

import { ItemContainer, Wrapper } from './styles'

function CasesSliderComponent({
  title,
  subtitle,
  config,
  padding,
  textTransform = 'none',
  textAlign = '',
  titlePosition = '',
}) {
  return (
    <Wrapper className="wrapper" zIndex="2">
      {title && subtitle && (
        <Description
          title={title}
          subtitle={subtitle}
          padding={padding}
          textTransform={textTransform}
          textPosition={textAlign}
          titlePosition={titlePosition}
        />
      )}
      <Slider>
        {config.map(item => (
          <ItemContainer key={`${item.id}_${item.alt}`}>
            <Case {...item} />
          </ItemContainer>
        ))}
      </Slider>
    </Wrapper>
  )
}

const CasesSlider = memo(CasesSliderComponent)

export default CasesSlider
